import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';

export default function free4Box(props) {

  useEffect(() => {
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  const handleClick = (a, b, c, d) => {
    let conver_current_s = (parseInt(d) + 1);
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '상단영역_자유형(4개)',
        clickType: 'NC',
        value1: b.pc_img_attr,
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };

  return (
      <div className="swiper-slide slide-slide">
        <div className="swiper-cont">
          <div className="spotModuleGroup3">
            {props.data.contents.map((item, index) => {
              const isEmptyTitle = !item.title;

              return (
                  <div
                      key={'mtf4_' + index}
                      className={`spotModuleWrap_freeType2 spotModuleWrap_ContentPhoto ${isEmptyTitle ? 'type_noText' : ''}`}
                  >
                    {item.link_url ? (
                        <a
                            href={item.link_url}
                            onClick={(e) => handleClick(e, item, '4free', index)}
                            target={item.link_new_yn === 'Y' ? '_blank' : undefined}
                            rel={item.link_new_yn === 'Y' ? 'noopener noreferrer' : undefined}
                            className="spotModuleLink"
                        >
                    <span className="spotModuleImage_w">
                      <Image
                          src={item.pc_img_url}
                          className="spotModuleImg"
                          layout="fixed"
                          width={282}
                          height={450}
                          quality={item.imageQuality || 75}
                          alt={item.pc_img_attr}
                      />
                    </span>
                          <div className="spotProgramCont">
                            <strong className="spotProgram-Title">{item.title}</strong>
                          </div>
                        </a>
                    ) : (
                        <div className="spotModuleLink">
                    <span className="spotModuleImage_w">
                      <Image
                          src={item.pc_img_url}
                          className="spotModuleImg"
                          layout="fixed"
                          width={282}
                          height={450}
                          quality={item.imageQuality || 75}
                          alt={item.pc_img_attr}
                      />
                    </span>
                          <div className="spotProgramCont">
                            <strong className="spotProgram-Title">{item.title}</strong>
                          </div>
                        </div>
                    )}
                  </div>
              );
            })}
          </div>
        </div>
      </div>
  );
}
